// extracted by mini-css-extract-plugin
export var container = "_7r-0";
export var fallback = "_7r-5";
export var fallbackIcon = "_7r-6";
export var hidden = "_7r-2";
export var image = "_7r-3";
export var loaded = "_7r-4";
export var placeholder = "_7r-1";